import { SlackLogo } from './SlackLogo';

interface SlackTitleProps {
  children: React.ReactNode;
}

/** Step title ending in the Slack mark and word, e.g. "Bring Finlay into Slack". */
export const SlackTitle = ({ children }: SlackTitleProps) => (
  <>
    {children}{' '}
    <SlackLogo className="mr-1 inline-block size-[0.75em] align-[-0.08em]" />
    Slack
  </>
);
